var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementBase } from './element-base';
import { ArrowHeaders } from '../shared/arrow-headers';
import { ArrowStyleType } from '../../../../view-data/shared/line/general/arrow-style-type';
import { LineStyleType } from '../../../../view-data/shared/line/general/line-style-type';
import * as go from '../../../../../libs/gojs/release/go';
var LineElement = /** @class */ (function (_super) {
    __extends(LineElement, _super);
    function LineElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineElement.prototype.hasDynamicSetting = function (data) {
        return data && data.dynamicSetting &&
            (data.dynamicSetting.isHorizontalTranslation || data.dynamicSetting.isVerticalTranslation || data.dynamicSetting.isRotation);
    };
    LineElement.prototype.isStartArrowVisible = function (data) {
        return data.isArrow &&
            (data.arrowStyle === ArrowStyleType.CommonLeft ||
                data.arrowStyle === ArrowStyleType.CommonBoth ||
                data.arrowStyle === ArrowStyleType.SolidLeft ||
                data.arrowStyle === ArrowStyleType.SolidBoth);
    };
    LineElement.prototype.isEndArrowVisible = function (data) {
        return data.isArrow &&
            (data.arrowStyle === ArrowStyleType.CommonRight ||
                data.arrowStyle === ArrowStyleType.CommonBoth ||
                data.arrowStyle === ArrowStyleType.SolidRight ||
                data.arrowStyle === ArrowStyleType.SolidBoth);
    };
    LineElement.prototype.getArrowAngle = function (data, isStartPoint) {
        var geo = data.geo;
        if (!geo) {
            return 0;
        }
        var geometry = go.Geometry.parse(geo);
        if (!geometry) {
            return 0;
        }
        var points = this.getPoints(geometry);
        if (!points) {
            return 0;
        }
        var rawAngle = data.angle ? data.angle : 0;
        var w = geometry.bounds.width;
        if (w === 0) {
            w = 0.001;
        }
        var h = geometry.bounds.height;
        if (h === 0) {
            h = 0.001;
        }
        var size = go.Size.parse(data.size);
        if (!data.size || !size.isReal()) {
            size = geometry.bounds.size;
        }
        var sx = size.width / w;
        var sy = size.height / h;
        var startPoint = new go.Point(points.startPoint.x * sx, points.startPoint.y * sy).rotate(rawAngle);
        var endPoint = new go.Point(points.endPoint.x * sx, points.endPoint.y * sy).rotate(rawAngle);
        if (points.secondPoint) {
            var secondPoint = new go.Point(points.secondPoint.x * sx, points.secondPoint.y * sy).rotate(rawAngle);
            var lastSecondPoint = new go.Point(points.lastSecondPoint.x * sx, points.lastSecondPoint.y * sy).rotate(rawAngle);
            if (isStartPoint) {
                return startPoint.directionPoint(secondPoint);
            }
            else {
                return lastSecondPoint.directionPoint(endPoint);
            }
        }
        else {
            return startPoint.directionPoint(endPoint);
        }
    };
    LineElement.prototype.getArrowAlignment = function (data, isStartPoint) {
        var geo = data.geo;
        if (!geo) {
            return undefined;
        }
        var strokeWidth = data.strokeWidth;
        if (strokeWidth === undefined) {
            strokeWidth = 1;
        }
        var geometry = go.Geometry.parse(geo);
        if (!geometry) {
            return go.Spot.Default;
        }
        var points = this.getPoints(geometry);
        if (!points) {
            return go.Spot.Default;
        }
        var rawAngle = data.angle ? data.angle : 0;
        var halfStrokeWidth = strokeWidth / 2.0;
        var b = geometry.bounds;
        var w = b.width;
        if (w === 0) {
            w = 0.001;
        }
        var h = b.height;
        if (h === 0) {
            h = 0.001;
        }
        var size = go.Size.parse(data.size);
        if (!data.size || !size.isReal()) {
            size = b.size;
        }
        var sx = size.width / w;
        var sy = size.height / h;
        var rx = isStartPoint ? points.startPoint.x : points.endPoint.x;
        var ry = isStartPoint ? points.startPoint.y : points.endPoint.y;
        var newRect = this.rotateRect(rawAngle, (w * sx) / 2.0, (h * sy) / 2.0, 0, 0, (w * sx), (h * sy));
        var originPoint = new go.Point((rx * sx) - newRect.x, (ry * sy) - newRect.y);
        var centerX = newRect.width / 2.0;
        var centerY = newRect.height / 2.0;
        var p = originPoint.offset(-centerX, -centerY).rotate(rawAngle).offset(centerX, centerY);
        var x = p.x;
        var y = p.y;
        var bw = newRect.width;
        if (bw === 0) {
            bw = 0.001;
        }
        var bh = newRect.height;
        if (bh === 0) {
            bh = 0.001;
        }
        return new go.Spot(Math.max(0, Math.min((x - b.x + halfStrokeWidth) / (bw + strokeWidth), 1)), Math.max(0, Math.min((y - b.y + halfStrokeWidth) / (bh + strokeWidth), 1)));
    };
    LineElement.prototype.getAlignmentFocus = function (data, isStartPoint) {
        var geo = data.geo;
        if (!geo) {
            return undefined;
        }
        var strokeWidth = data.strokeWidth;
        if (strokeWidth === undefined) {
            strokeWidth = 1;
        }
        var geometry = go.Geometry.parse(geo);
        if (!geometry) {
            return go.Spot.Default;
        }
        var points = this.getPoints(geometry);
        if (!points) {
            return go.Spot.Default;
        }
        var arrowStyle = data.arrowStyle;
        var halfStrokeWidth = strokeWidth / 2.0;
        var angle;
        if (isStartPoint) {
            angle = this.getArrowAngle(data, true);
        }
        else {
            angle = this.getArrowAngle(data, false);
        }
        var arrowGeo = isStartPoint ? this.getStartArrow(arrowStyle) : this.getEndArrow(arrowStyle);
        var w = arrowGeo.bounds.width;
        var h = arrowGeo.bounds.height;
        var newRect = this.rotateRect(angle, (w + strokeWidth) / 2.0, (h + strokeWidth) / 2.0, 0, 0, (w + strokeWidth), (h + strokeWidth));
        var spot = isStartPoint ? new go.Spot(0, 0.5) : new go.Spot(1, 0.5);
        var originPoint = new go.Point((w * spot.x + halfStrokeWidth) - newRect.x, (h * spot.y + halfStrokeWidth) - newRect.y);
        var centerX = newRect.width / 2.0;
        var centerY = newRect.height / 2.0;
        var p = originPoint.offset(-centerX, -centerY).rotate(angle).offset(centerX, centerY);
        return new go.Spot(p.x / newRect.width, p.y / newRect.height);
    };
    LineElement.prototype.getStartArrow = function (arrowStyle) {
        if (arrowStyle === undefined) {
            return undefined;
        }
        switch (arrowStyle) {
            case ArrowStyleType.CommonLeft:
            case ArrowStyleType.CommonBoth:
                return ArrowHeaders.get('BackwardOpenTriangle');
            case ArrowStyleType.SolidLeft:
            case ArrowStyleType.SolidBoth:
                return ArrowHeaders.get('BackwardTriangle');
            default:
                return undefined;
        }
    };
    LineElement.prototype.getEndArrow = function (arrowStyle) {
        if (arrowStyle === undefined) {
            return undefined;
        }
        switch (arrowStyle) {
            case ArrowStyleType.CommonRight:
            case ArrowStyleType.CommonBoth:
                return ArrowHeaders.get('OpenTriangle');
            case ArrowStyleType.SolidRight:
            case ArrowStyleType.SolidBoth:
                return ArrowHeaders.get('Triangle');
            default:
                return undefined;
        }
    };
    LineElement.prototype.getPoints = function (geometry) {
        if (geometry.figures.count <= 0) {
            return undefined;
        }
        var fig = geometry.figures.elt(0);
        if (!fig) {
            return undefined;
        }
        if (fig.segments.count <= 0) {
            return undefined;
        }
        if (fig.segments.count === 1) {
            var end = fig.segments.elt(0);
            if (!end) {
                return undefined;
            }
            return { startPoint: new go.Point(fig.startX, fig.startY), endPoint: new go.Point(end.endX, end.endY) };
        }
        else {
            var second = fig.segments.elt(0);
            var lastSecond = fig.segments.elt(fig.segments.count - 2);
            var end = fig.segments.elt(fig.segments.count - 1);
            if (!end) {
                return undefined;
            }
            return { startPoint: new go.Point(fig.startX, fig.startY),
                secondPoint: new go.Point(second.endX, second.endY),
                lastSecondPoint: new go.Point(lastSecond.endX, lastSecond.endY), endPoint: new go.Point(end.endX, end.endY) };
        }
    };
    LineElement.prototype.rotateRect = function (angle, ox, oy, x, y, w, h) {
        angle = angle * Math.PI / 180.0;
        var xAx = Math.cos(angle); // x axis x
        var xAy = Math.sin(angle); // x axis y
        x -= ox; // move rectangle onto origin
        y -= oy;
        var points = [
            [
                x * xAx - y * xAy + ox,
                x * xAy + y * xAx + oy,
            ],
            [
                (x + w) * xAx - y * xAy + ox,
                (x + w) * xAy + y * xAx + oy,
            ],
            [
                (x + w) * xAx - (y + h) * xAy + ox,
                (x + w) * xAy + (y + h) * xAx + oy,
            ],
            [
                x * xAx - (y + h) * xAy + ox,
                x * xAy + (y + h) * xAx + oy,
            ]
        ];
        var left = Math.min(points[0][0], points[1][0], points[2][0], points[3][0]);
        var right = Math.max(points[0][0], points[1][0], points[2][0], points[3][0]);
        var top = Math.min(points[0][1], points[1][1], points[2][1], points[3][1]);
        var bottom = Math.max(points[0][1], points[1][1], points[2][1], points[3][1]);
        return new go.Rect(left, top, (right - left), (bottom - top));
    };
    LineElement.prototype.getStrokeDasharray = function (lineType) {
        if (lineType === undefined) {
            return [];
        }
        switch (lineType) {
            case LineStyleType.Dash:
                return [10, 3];
            case LineStyleType.Dot:
                return [5, 3];
            case LineStyleType.DashDot:
                return [15, 5, 5, 5];
            case LineStyleType.DashDotDot:
                return [15, 5, 5, 5, 5, 5];
            default:
                return [];
        }
    };
    return LineElement;
}(ElementBase));
export { LineElement };
